import React, { Component } from 'react'
import '../styles/Landing.css'
import Hero from './Hero'
import ThemesContainer from './ThemesContainer'
import BookingContainer from './BookingContainer'
import SpecialOccasions from './SpecialOccasions'
import Footer from './Footer'
import { Link } from 'react-router-dom'
import {Helmet} from 'react-helmet'
import { injectIntl, defineMessages } from 'react-intl'

const removeTransition = (element) => {
  element.classList.remove("site-transition--visible")
}

class Landing extends Component {

  toggleGlitch = () => {
    this.interval = setInterval(() => {
      this.randomizeGlitch()
    }, 1000)
  }

  randomizeGlitch = () => {
    let glitches = document.getElementsByClassName("glitch")
    let glitch = glitches[Math.floor(Math.random() * glitches.length)]

    if (!glitch.classList.contains("glitch--stopped")) {
      window.setTimeout(() => {
        glitch.classList.add("glitch--stopped")
        window.setTimeout(() => {
          glitch.classList.remove("glitch--stopped")
        }, 500)
      }, 10)
    }
  }

  componentDidMount() {
    const glitchTransition = document.getElementById("site-transition")
    window.setTimeout(() => {
      glitchTransition.classList.add("site-transition--visible")
      window.setTimeout(() => {
        removeTransition(glitchTransition)
      }, 500)
    }, 10)
    this.toggleGlitch()
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }
  render() {
    const {intl:{formatMessage}} = this.props
    return (
      <div className="landing">
        <Helmet>
          <title>Escape game Paris - One Hour jeux immersifs à Paris</title>
          <meta name="description" content={formatMessage(messages.metaDescription)}/>

			<meta property="og:type" content="website"/>
			<meta property="og:url" content="https://www.one-hour.fr/"/>
			<meta property="og:title" content="Escape game Paris - One Hour jeux immersifs à Paris<"/>
			<meta property="og:description" content="Découvrez One Hour à Paris, le top de l'escape game à Paris. Entre amis, famille ou comité d'entreprise, nos salles sont ouverts 7j/7"/>
			<meta property="og:image" content="https://www.one-hour.fr/static/media/OHpresse27.jpg"/>

			<meta property="twitter:card" content="summary_large_image"/>
			<meta property="twitter:url" content="https://www.one-hour.fr/"/>
			<meta property="twitter:title" content="Escape game Paris - One Hour jeux immersifs à Paris<"/>
			<meta property="twitter:description" content="Découvrez One Hour à Paris, le top de l'escape game à Paris. Entre amis, famille ou comité d'entreprise, nos salles sont ouverts 7j/7"/>
			<meta property="twitter:image" content="https://www.one-hour.fr/static/media/OHpresse27.jpg"/>
			<html lang="fr" />
			<link rel="apple-touch-icon" href="https://www.one-hour.fr/static/media/apple-touch-icon.png" />
        </Helmet>
        <Hero
          handleLang={(lang) => this.props.handleLang(lang)}
          lang={this.props.lang}
        />
        <ThemesContainer />
        <BookingContainer
          expiration={() => this.props.handleExpiration()}
          lang={this.props.lang}
         />
        <SpecialOccasions />
        <Footer />
      </div>
    );
  }
}

const messages = defineMessages({
  metaDescription: {
    id: 'landing.metaDescription',
    defaultMessage: "Découvrez One Hour escape game Paris, ou jeu d'évasion immersif sur Paris. Entre amis, famille ou comité d'entreprise, nos salles sont ouverts 7j/7"
  },
})

export default injectIntl(Landing)



// WEBPACK FOOTER //
// ./src/components/Landing.js